<template>
    <div>
        <b-col>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label
                            class="required"
                        >
                            <strong>O quê deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group v-model="contratoApostilamento"  @change="alternaJustificativa($event)">
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group>
                        <label
                            class="required"
                        >Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback>A justificativa {{textoInfoJustificativa}} é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-tabs>
                <b-tab title="Cabeçalho">
                    <cabecalho
                        :tiposProduto="tiposProduto"
                        :statusContratoOptions="statusContratoOptions"
                        :tiposFaturamento="tiposFaturamento"
                        :contrato="contrato"
                        :acao="acao"
                        :item="item"
                        :naturezaItemOptions="naturezaItemOptions" 
                        @atualizarCabecalho="atualizarCabecalho($event)" 
                    ></cabecalho>
                </b-tab>
                <b-tab title="Condições Gerais">
                    <condicoes-gerais
                        :condicoesPagamento="condicoesPagamento"
                        :locaisFaturamento="filteredLocaisFaturamento"
                        :contrato="contrato"
                        :acao="acao"
                        :item="item"
                        @atualizarCondicoesGerais="atualizarCondicoesGerais($event)"
                    ></condicoes-gerais>
                </b-tab>
                <b-tab title="Tabelas">
                    <tabelas
                        :cCustos="cCustos"
                        :orcamentos="orcamentos"
                        :departamentos="filteredDepartamentos"
                        :despesasReceita="despesasReceita"
                        :vendedores="vendedores"
                        :acao="acao"
                        :item="item"
                        :filial="filial"
                        @atualizarTabelas="atualizarTabelas($event)"
                    ></tabelas>
                </b-tab>
                <b-tab title="Observação">
                    <observacao
                        :item="item"
                        :acao="acao"
                        @atualizarObservacao="atualizarObservacao($event)"
                    ></observacao>
                </b-tab>
            </b-tabs> 
            <div class="d-flex flex-row-reverse mt-3">
                <b-form-group>
                    <b-button variant="danger" @click.stop="voltar()">
                        <span>
                            <i class="fa fa-history mr-2"></i> Retornar para Itens
                        </span>
                    </b-button>
                    <b-button
                        variant="primary"
                        @click.stop="confirmarAcao()"
                        class="ml-1"
                        :disabled="!habilitarBtnSalvar"
                    >{{ this.acao }}</b-button>
                </b-form-group> 
            </div>
        </b-col>
    </div>
</template>

<script>
import ContratosRMServicos from '../../rm/ContratosRMServicos'
import Cabecalho from './inserirItemTabs/cabecalho.vue'
import CondicoesGerais from './inserirItemTabs/condicoesgerais.vue'
import Tabelas from './inserirItemTabs/tabelas.vue'
import Observacao from './inserirItemTabs/observacao.vue'
import { ModelListSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { situacaoContrato } from '../SituacaoContrato'
import ContratosServicos from '../ContratosServicos'


export default {
    props: {
        contrato: {
            type: Object,
            default: () => {}
        },  
        item: {
            type: Object,
            default: () => {}
        },
        acao: {
            type: String,
            default: () => ""
        },
        apostilamento: {
            type: Boolean,
            default: () => false
        },
    },

    components: {
        Cabecalho,
        CondicoesGerais,
        ModelListSelect,
        Tabelas,
        Observacao
    },
    
    data() {
        return {
            cabecalhoDados: {
                desconto: '',
                quantidade: '',
                statusContrato:'',
                tipoFaturamento: '',
                tipoMedicao: '',
                tipoProduto: '',
                // unidade: '',
                valor: '',
                invalid: ''
            },
            condicoesGeraisDados: {
                condicaoPagamento: '',
                localFaturamento: '',
                fornecedor: {
                    cnpjcpf: '',
                    razaoSocial: '',
                    codFornecedor: ''
                },
                vigenciaInicio: '',
                vigenciaFim: '',
                invalid: '',
            },
            tabelasDados: {
                cCusto: '',
                departamento: '',
                despesaReceita: '',
                orcamento: '',
                vendedor1: '',
                vendedor2: '',
                invalid: '',
            },
            observacaoDados: {
                campoLivre1: '',
                campoLivre2: ''
            },
            tiposProdutoFaturamento: [],
            tiposFaturamento: [
                {
                    codigo: 0,
                    descricao: "Não periódico"
                },
                {
                    codigo: 1,
                    descricao: "Periódico"
                },
                {
                    codigo: 2,
                    descricao: "Por Medição"
                }
            ],
            cCustos: [],
            orcamentos: [],
            naturezas: [],
            tiposProduto: [],
            condicoesPagamento: [],
            departamentos: [],
            despesasReceita: [],
            statusContratoOptions: [],
            vendedores: [],
            locaisFaturamento: [],
            // unidades: [],
            seqRm: '',
            isApostilamento: false,
            erros: [],
            contratoApostilamento: null,
            justificativaApostilamento: '',
            labelJustificativa: '',
            textoInfoJustificativa: '',
            naturezaContrato: '',
            naturezaItem: '',
            // TODO: mover listagem para o devido lugar
            naturezaItemOptions: [
                {
                codigo: '0',
                descricao: "Venda"
                },
                {
                codigo: '1',
                descricao: "Compra"
                },
                {
                codigo: '2',
                descricao: "Ambos"
                }
            ],
            filial: null
        }
    },
    
    methods: {
        voltar() {
            this.$emit('fecharInserirAtualizarItem')
        },

        obterDadoNovoItem() {
            this.$store.dispatch('addRequest')
            ContratosRMServicos.obterDadosNovoItem(this.naturezaContrato).then((response) => {
                if (response && response.success){
                    this.tiposProdutoFaturamento = response.data.tiposProdutoFaturamentoDto
                    this.cCustos = response.data.cCustosDto
                    this.orcamentos = response.data.orcamentoRMDto
                    this.naturezas = response.data.tiposNaturezaDto
                    this.tiposProduto = response.data.tiposProdutoDto
                    this.condicoesPagamento = response.data.condicoesPagamentoDto
                    this.departamentos = response.data.departamentosDto
                    this.despesasReceita = response.data.despesasReceitasDto
                    this.statusContratoOptions = response.data.statusContratoDto
                    this.vendedores = response.data.vendedoresDto
                    this.locaisFaturamento = response.data.locaisFaturamentoRMDto
                    // this.unidades = response.data.unidadesDto
                    this.$store.dispatch('removeRequest')
                }else{
                    this.erros = response.erros
                    this.$store.dispatch('removeRequest')
                }
            })
        },

        atualizarCabecalho(cabecalhoDados) {
            this.cabecalhoDados = cabecalhoDados
        },

        atualizarCondicoesGerais(condicoesGerais) {
            this.condicoesGeraisDados = condicoesGerais
        },

        atualizarTabelas(tabelas) {
            this.tabelasDados = tabelas
        },  
        atualizarObservacao(observacao) {
            this.observacaoDados = observacao
        },  

        buscaElemento(colecao, elementoCod) {
            return colecao.find((x) => x.codigo == elementoCod)
        },
        buscaElementoCCusto(colecao, elementoCod) {
            return colecao.find((x) => x.codCCusto == elementoCod)
        },
    
        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },
    
        confirmarAcao() {
            let mudanca = 'inserção'
            if (this.acao == 'Atualizar'){
                mudanca = 'atualização'
            }
            this.$swal({
                title: 'Item do Contrato',
                html: `Confirma a ${mudanca} do item no contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let itemNovoDto = {
                idContrato: this.$route.params.contratoId,
                itemContratoId: this.item != null ? this.item.itemContratoId : 0,
                itemReferenciaId: 0,
                seqRm: this.seqRm,
                statusContrato: this.buscaElemento(this.statusContratoOptions, this.cabecalhoDados.statusContrato),
                tipoFaturamento: this.buscaElemento(this.tiposFaturamento, this.cabecalhoDados.tipoFaturamento),
                naturezaItem: this.buscaElemento(this.naturezaItemOptions, this.cabecalhoDados.naturezaItem),
                tipoProduto: this.buscaElemento(this.tiposProduto, this.cabecalhoDados.tipoProduto),
                // unidade: this.buscaElemento(this.unidades, this.cabecalhoDados.unidade),
                quantidade: this.cabecalhoDados.quantidade,
                valor: this.cabecalhoDados.valor,
                desconto: this.cabecalhoDados.desconto,
                descricao: this.cabecalhoDados.descricao.trim(),
                descricaoResumida: this.cabecalhoDados.descricaoResumida.trim(),
                condicaoPagamento: this.buscaElemento(this.condicoesPagamento, this.condicoesGeraisDados.condicaoPagamento),
                localFaturamento: this.buscaElemento(this.locaisFaturamento, this.condicoesGeraisDados.localFaturamento),
                fornecedor: {
                    codFornecedor: this.condicoesGeraisDados.fornecedor.codFornecedor,
                    nome: this.condicoesGeraisDados.fornecedor.nome
                },
                vigenciaInicio: this.$moment( 
                    this.condicoesGeraisDados.vigenciaInicio,
                    'DD/MM/YYYY'
                ),
                vigenciaFim: this.$moment( 
                    this.condicoesGeraisDados.vigenciaFim,
                    'DD/MM/YYYY'
                ),
                cCusto: this.buscaElementoCCusto(this.cCustos, this.tabelasDados.cCusto),
                orcamento: this.buscaElemento(this.orcamentos, this.tabelasDados.orcamento),
                // departamento: this.buscaElemento(this.departamentos, this.tabelasDados.departamento),
                // despesaReceita: this.buscaElemento(this.despesasReceita, this.tabelasDados.despesaReceita), 
                // vendedor1: this.buscaElemento(this.vendedores, this.tabelasDados.vendedor1),
                // vendedor2: this.buscaElemento(this.vendedores, this.tabelasDados.vendedor2),
                campoLivre1: this.observacaoDados.campoLivre1,
                campoLivre2: this.observacaoDados.campoLivre2,
                isApostilamento: this.contratoApostilamento == 1 ? true : false,
                justificativaApostilamento: this.justificativaApostilamento,
            }
            this.$store.dispatch('addRequest')
            ContratosServicos.atualizarItemContrato(itemNovoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            let msg = 'Registro inserido com sucesso!' 
                            if (this.acao == 'Atualizar'){
                                msg = 'Registro atualizado com sucesso!'
                            }
                            this.$toast.success(
                                msg,
                                'OK',
                                this.$toastConfig.success
                            )
                            
                            this.$emit('obterItensAtualizados')
                            this.voltar()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterSeqRM() {
            this.$store.dispatch('addRequest')
            ContratosRMServicos.obterItenPorContrato(this.contrato.idRM).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            // this.itensContratoRM = response.data
                            // this.itensContratoRM = this.itensContratoRM.map(
                            //     (item) => {
                            //         return {
                            //             seqRm: item.seqRm,
                            //             descricao: `NSEQ: ${item.seqRm} - ${item.descricao} - Valor: ${item.valor}`
                            //         }
                            //     }
                            // )
                            response.data.forEach(item => {
                                if (item.seqRm > this.seqRm) {
                                    this.seqRm = item.seqRm
                                }
                            });
                            this.seqRm += 1 
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },
    },

    created() {
        this.naturezaContrato = this.contrato.dadosContratoRM.naturezaContratoRMDto.codigo
        this.filial = this.contrato.dadosContratoRM.filialRMDto.codigo
        this.obterSeqRM()
        this.obterDadoNovoItem()
    },

    computed: {
        mostrarCheckApostilamento() {
            return this.atualizacaoContrato() && this.apostilamento
        },
        habilitarBtnSalvar(){
            if (this.mostrarCheckApostilamento){
                return !this.$v.$invalid && this.tabelasValidas
            }
            return this.tabelasValidas
        },
        tabelasValidas(){
            return !this.cabecalhoDados.invalid && !this.condicoesGeraisDados.invalid && !this.tabelasDados.invalid && !this.observacaoDados.invalid
        },
        filteredDepartamentos() {
            return this.departamentos.filter(d => {
                return d.codFilial == this.filial
            });
        },
        filteredLocaisFaturamento() {
            return this.locaisFaturamento.filter(lf => {
                return lf.codFilial == this.filial
            });
        }
    },

    watch: {},

    validations: {
        justificativaApostilamento: {
            required,
        },
        contratoApostilamento: {
            required
        }
    }
}
</script>

<style>

</style>

